import React, { memo } from 'react';
import { useRouter } from 'next/router';
import classnames from 'classnames';
import { Button, Element } from '../base';
import { RouterLink } from '../links';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/constants';
import { convertTabId } from '@zmedia/bm-soccer-ui/modules/shared';
import styles from './style.module.scss';

export interface ITab {
    id: string;
    title: string;
    position?: number;
}

export interface IProps {
    tabs: ITab[];
    className?: string;
    pathUrl?: string;
    activeTab?: string;
}

function Tabs({
    tabs = [],
    className,
    pathUrl,
    activeTab = '',
    ...rest
}: IProps) {
    const router = useRouter();

    let params = router.asPath.split('?')[1] || '';
    if (params) {
        params = '?' + params;
    }

    return (
        <Element className={classnames(styles['ut-tabs'], className)} {...rest}>
            <Element className={styles['tabs-list']}>
                {tabs.map((tab) => {
                    const tabId = convertTabId(tab.id);
                    const url = (tabId ? tabId + '-' : '') + pathUrl + params;

                    return pathUrl ? (
                        <RouterLink
                            key={tab.title}
                            to={URL_SOCCER_PAGE.SUBPATH + url}
                            className={classnames(styles['link'], {
                                [styles['active']]: activeTab === tabId,
                            })}
                            title={tab.title}
                        >
                            <Element renderAs='p'>{tab.title}</Element>
                        </RouterLink>
                    ) : (
                        <Button
                            key={tab.title}
                            onClick={() =>
                                window.scrollTo({
                                    top: tab.position ? tab.position - 90 : 0,
                                    behavior: 'smooth',
                                })
                            }
                            className={classnames(styles['link'], {
                                [styles['active']]: activeTab === tab.id,
                            })}
                            title={tab.title}
                        >
                            {tab.title}
                        </Button>
                    );
                })}
            </Element>
        </Element>
    );
}

export default memo(Tabs);
